<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>sync</mat-icon></div>
    <div>
      <span>Sincronizar con Bookcit</span>
      <small class="dlg-hdr__sub">{{ data.employeeName }}</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="cancel()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">

  <ng-container *ngIf="loading">
    <div class="bss-loading">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading">

    <div class="bss-section-label">Datos del empleado</div>

    <div class="bss-compare-grid">
      <div class="bss-col-hdr">
        <mat-icon class="bss-icon bss-icon--factu">business</mat-icon>
        <span>Handly</span>
      </div>
      <div class="bss-col-hdr-mid"></div>
      <div class="bss-col-hdr">
        <mat-icon class="bss-icon bss-icon--bookcit">event_available</mat-icon>
        <span>Bookcit</span>
      </div>

      <!-- Nombre -->
      <div class="bss-cell">
        <app-input inputType="text" placeholder="Nombre" [formControl]="form.get('factuName')"></app-input>
      </div>
      <div class="bss-arrows">
        <button mat-icon-button class="bss-arrow-btn" (click)="copyNameToBookit()" title="Copiar a Bookcit">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-icon-button class="bss-arrow-btn" (click)="copyNameFromBookit()" title="Copiar de Bookcit">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <div class="bss-cell">
        <app-input inputType="text" placeholder="Nombre en Bookcit" [formControl]="form.get('bookitName')"></app-input>
      </div>

      <!-- Email -->
      <div class="bss-cell">
        <app-input inputType="email" placeholder="Email" [formControl]="form.get('factuEmail')"></app-input>
      </div>
      <div class="bss-arrows">
        <button mat-icon-button class="bss-arrow-btn" (click)="copyEmailToBookit()" title="Copiar a Bookcit">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-icon-button class="bss-arrow-btn" (click)="copyEmailFromBookit()" title="Copiar de Bookcit">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <div class="bss-cell">
        <app-input inputType="email" placeholder="Email en Bookcit" [formControl]="form.get('bookitEmail')"></app-input>
      </div>
    </div>

    <div class="bss-section-label">Ubicaciones</div>

    <p *ngIf="rows.length === 0" class="bss-empty">No hay ubicaciones de Bookcit configuradas.</p>

    <div *ngIf="rows.length > 0" class="bss-locations">
      <div class="bss-loc-hdr">Ubicación</div>
      <div class="bss-loc-hdr">Rol</div>

      <ng-container *ngFor="let row of rows">
        <div class="bss-loc-cell">
          <mat-checkbox [formControl]="row.checkControl">{{ row.name }}</mat-checkbox>
        </div>
        <div class="bss-loc-cell">
          <app-select class="bss-role-field" [formControl]="row.roleControl" [config]="{ options: roleOptions }"></app-select>
        </div>
      </ng-container>
    </div>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="cancel()" [disabled]="saving">Cancelar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="save()" [disabled]="saving || loading">
    <mat-icon *ngIf="!saving">sync</mat-icon>
    <mat-progress-spinner *ngIf="saving" mode="indeterminate" diameter="18" style="display:inline-block"></mat-progress-spinner>
    <span>{{ saving ? 'Sincronizando...' : 'Sincronizar' }}</span>
  </button>
</mat-dialog-actions>
